/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Upgrade_For_MoreInputs */

const en_common_upgrade_for_more = /** @type {(inputs: Common_Upgrade_For_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade for more`)
};

const de_common_upgrade_for_more = /** @type {(inputs: Common_Upgrade_For_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgraden für mehr`)
};

const fr_common_upgrade_for_more = /** @type {(inputs: Common_Upgrade_For_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à niveau pour plus`)
};

const es_common_upgrade_for_more = /** @type {(inputs: Common_Upgrade_For_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar plan para más`)
};

const it_common_upgrade_for_more = /** @type {(inputs: Common_Upgrade_For_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna per avere di più`)
};

const nl_common_upgrade_for_more = /** @type {(inputs: Common_Upgrade_For_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade voor meer`)
};

const pl_common_upgrade_for_more = /** @type {(inputs: Common_Upgrade_For_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulepsz, aby uzyskać więcej`)
};

const fi_common_upgrade_for_more = /** @type {(inputs: Common_Upgrade_For_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä lisää`)
};

const da_common_upgrade_for_more = /** @type {(inputs: Common_Upgrade_For_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader for mere`)
};

const sv_common_upgrade_for_more = /** @type {(inputs: Common_Upgrade_For_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera för mer`)
};

/**
* | output |
* | --- |
* | "Upgrade for more" |
*
* @param {Common_Upgrade_For_MoreInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_upgrade_for_more = /** @type {((inputs?: Common_Upgrade_For_MoreInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Upgrade_For_MoreInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_upgrade_for_more(inputs)
	if (locale === "fr") return fr_common_upgrade_for_more(inputs)
	if (locale === "es") return es_common_upgrade_for_more(inputs)
	if (locale === "it") return it_common_upgrade_for_more(inputs)
	if (locale === "nl") return nl_common_upgrade_for_more(inputs)
	if (locale === "pl") return pl_common_upgrade_for_more(inputs)
	if (locale === "fi") return fi_common_upgrade_for_more(inputs)
	if (locale === "da") return da_common_upgrade_for_more(inputs)
	if (locale === "sv") return sv_common_upgrade_for_more(inputs)
	return en_common_upgrade_for_more(inputs)
});